import StandardQueryTable from "@/components/StandardQueryTable";
import { Module, PATH_PAYROLL } from "@/constants";
import { usePayrollBreadcrumbs } from "@/modules/payrolls/hooks/usePayrollBreadcrumbs";
import { usePayrollsColumnOverrides } from "@/modules/payrolls/hooks/usePayrollsColumnOverrides";
import { readPayroll } from "@/schemas/payroll";
import { PayrollsService } from "@/services/payrolls";
import { ReadPayroll } from "@/types/payroll";
import { memo, useCallback } from "react";
import { generatePath } from "react-router-dom";

export const PayrollsDirectory = memo(() => {
  const breadcrumbs = usePayrollBreadcrumbs();

  const columnOverrides = usePayrollsColumnOverrides();

  const pathBuilder = useCallback(
    (row: ReadPayroll) => generatePath(PATH_PAYROLL, { payrollId: row.id }),
    [],
  );

  return (
    <StandardQueryTable<ReadPayroll>
      schema={readPayroll}
      name={Module.Payrolls}
      fetchList={PayrollsService.getList}
      pathBuilder={pathBuilder}
      columnOverrides={columnOverrides}
      breadcrumbs={breadcrumbs}
      actions={[]}
    />
  );
});
